import { Injectable, OnDestroy } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthsFacade } from '@kion/data-access/data-access-auths';
import { CorrelationObserverService } from '@kion/ngrx-helper';
import { take } from 'rxjs/operators';
import { IdpConfig } from '../config/idp.config';
import { CookieService } from 'ngx-cookie-service';
import { UsersFacade } from '@kion/data-access/data-access-users';
import { SubSink } from 'subsink';
import { MsalService } from '@kion/core';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate, OnDestroy {

  private readonly subSink: SubSink;

  constructor(
    private authsFacade: AuthsFacade,
    private observer: CorrelationObserverService,
    private idpConfig: IdpConfig,
    private cookieService: CookieService,
    private usersFacade: UsersFacade,
    private msalService: MsalService
  ) {
    this.subSink = new SubSink();
  }

  ngOnDestroy(): void {
    this.subSink.unsubscribe();
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    let isAuth: boolean;
    this.subSink.sink = this.authsFacade.all$.pipe(take(1)).subscribe(
      auths => {
        const auth = auths.find(a => a.id === 1);
        if (auth && auth.client) {
          if (auth.client.expireDate) {
            if (new Date() >= new Date(auth.client.expireDate)) {
              this.authsFacade.clientAuth('clientAuth');
            }
          }
        }
        if (!auth || !auth.client) {
          this.subSink.sink = this.observer.subscribeToAction(
            this.authsFacade.clientAuth('clientAuth'),
            () => {
              this.silentSSO(state.url);
              isAuth = true;
              console.log('client auth successfully')
            },
            () => isAuth = false
          )
        }
        if (auth && auth.user) {
          if (auth.user.expireDate) {
            if (new Date() >= new Date(auth.user.expireDate)) {
              this.silentSSO(state.url)
            }
          }
          this.subSink.sink = this.observer.subscribeToAction(
            this.authsFacade.checkWhoAmI(auth.user.accessToken),
            () => {},
            () => this.authsFacade.refreshToken(auth.user.refreshToken)
          )
        }
        //nur wenn cookie
        if (auth && !auth.user ) {
          this.silentSSO(state.url)
        }
        this.usersFacade.loadUserById();
      }
    );
    return isAuth ? isAuth : true;
  }

  private silentSSO(url: string): void {
    if (url.indexOf('access/invite/user') !== -1) {
      return;
    }
    const account = this.msalService.getAccount();
    if (account && !this.cookieService.get('_isLogin')) {
      if (!this.cookieService.get('_redirect')) {
        this.cookieService.set('_redirect', url, 200, '/', null, true, "Strict");
      }
      this.cookieService.set('_noToast', url, 200, '/', null, true, "Strict");
      this.cookieService.set('_isLogin', 'true', 200, '/', null, true, "Strict");
    }
  }
}
